import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../search.module.css';
import { Download } from 'lucide-react'; 
import { checkAuthStatus } from '../utills/authChecker';
import { apiCall } from '../utills/APICall';

export default function SearchResults({ results, showResults }) {
  const resultsRef = useRef(null);
  const navigate = useNavigate();
  const { isLoggedIn, isAdmin, tokenValid } = checkAuthStatus(); 

  const handleDownload = async (domain) => {
    console.log("Download button clicked for domain:", domain);
    
    try {
      const response = await apiCall("start-download", "POST", { domain });
      console.log("API Response:", response);

      // Check if response exists and has the expected structure
      if (response && response.success) {
        // Handle different response structures
        const progressId = response.data?.progressId || response.data?.data?.progressId;
        
        if (progressId) {
          const downloadItem = {
            domain,
            progressId,
          };

          console.log("Redirecting to /download with:", downloadItem);
          // Ensure navigation happens correctly
          return navigate("/download", { state: downloadItem });
        }
      }
      
      // If we get here, something went wrong
      console.warn("Invalid response structure:", response);
      alert("Failed to start download. Please try again.");
      
    } catch (error) {
      console.error("Download error:", error);
      alert("An error occurred while starting the download.");
    }
  };

  if (!showResults) {
    return null;
  }

  return (
    <div ref={resultsRef} className={styles.searchResults}>
      <div className={styles.resultsHeader}>
        <h3 className={styles.resultsTitle}>
          {results.length} result{results.length !== 1 ? 's' : ''} for your search
        </h3>
      </div>
      <div className={styles.resultsList}>
        {results.map((result, index) => (
          <div key={index} className={styles.resultItem}>
            <div className={styles.resultContent}>
              <h4 className={styles.resultItemTitle}>
                Email Pattern: {result.emailPattern}
              </h4>
              <span className={styles.resultUrl}>
                Domain: {result.domain}
              </span>
            </div>
            <div className={styles.resultMeta}>
              <span className={styles.confidenceBadge}>
                Employee Count: {result.employeeCount}
              </span>
              {isLoggedIn && isAdmin && tokenValid && (
                <button
                  className={styles.downloadButton}
                  onClick={() => handleDownload(result.domain)}
                  aria-label={`Download data for ${result.domain}`}
                >
                  <Download className={styles.downloadIcon} />
                  Download
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}